import { BaseInput } from './base-input';

export class YesNoInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
